import { render, staticRenderFns } from "./ContractTypes.vue?vue&type=template&id=4fa63a58&lang=pug&"
import script from "./ContractTypes.vue?vue&type=script&lang=js&"
export * from "./ContractTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports